import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { userPermissionListSelectors } from '@content-platform/web/angular/shared/data-access/application-api/src/lib/selectors';
import { UserMenuItem } from '@content-platform/web-angular-shared-ui-navigation';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '@content-platform/web-angular-shared-data-access-feature-flag-api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  version = Configuration.get('version');
  hasPermission$: Observable<boolean>;
  extraMenuItems: UserMenuItem[] = [];
  headerDisplayName: string;
  private logger: LoggerService;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    private store: Store<{}>,
    loggerService: LoggerService,
    private featureFlagsService: WebAngularSharedDataAccessFeatureFlagApisService
  ) {
    this.hasPermission$ = this.store.pipe(select(userPermissionListSelectors.hasUserPermission));
    this.logger = loggerService.instance('Home App');
    this.featureFlagsService = featureFlagsService;

    // Start of code to be removed when show-new-title flag is fully deployed - DS
    const titleSelect$ = this.featureFlagsService.getFlagAsync('show-new-title');
    titleSelect$.subscribe((showNewTitle) => {
      if (showNewTitle) {
        // End of code to be removed when show-new-title flag is fully deployed - DS
        this.headerDisplayName = 'ViacomCBS Application Platform';
        // Start of code to be removed when show-new-title flag is fully deployed - DS
      } else {
        this.headerDisplayName = 'The Content Platform';
      }
    });
    // End of code to be removed when show-new-title flag is fully deployed - DS

    
  }

  ngOnInit(): void {
    this.logger.log('Started Home App');
  }
  
}

